const activeClass = 'is-active';

const CALLBACK_ID = 'js-ajax-callback-message';
const CALLBACK_BUTTON = 'js-ajax-callback-button';
const CALLBACK_MESSAGE_CLASS = 'callout-ajax-callback';
const CALLBACK_MESSAGE_TIMER = 5000;

// Callback template
const ajaxCallbackTemplate = `<div class="${CALLBACK_MESSAGE_CLASS}">
    <p id="${CALLBACK_ID}"></p>
    <div class="callout-ajax-callback-button show-for-medium">
      <button type="button" id="js-ajax-callback-button" class="button white">J'ai compris</button>
    </div>
  </div>`;

/**
 * Init Ajax Callback message
 */
const initAjaxCallbackMessage = () => (document.getElementById('js-ajax-callback').innerHTML += ajaxCallbackTemplate);

/**
 * Ajax call back
 * @param {string} message
 */
const showAjaxCallbackMessage = message => {
  const $callback = document.getElementById(CALLBACK_ID);
  const $callbackParent = $callback.parentNode;
  const $callbackButton = document.getElementById(CALLBACK_BUTTON);

  $callback.innerHTML = message;
  $callbackParent.classList.add(activeClass);

  // Close $callback on click
  $callbackButton.addEventListener('click', () =>
    $callbackParent.classList.remove(activeClass)
  );

  // Close after CALLBACK_MESSAGE_TIMER delay
  setTimeout(
    () => $callbackParent.classList.remove(activeClass),
    CALLBACK_MESSAGE_TIMER
  );
};

export { initAjaxCallbackMessage, showAjaxCallbackMessage };
